import type { FC } from 'react';
import { SvgIcon } from './svg-icon';
import styles from '../styles/attention-box.module.scss';

const AttentionBox: FC<{
    title: string;
    messages: string[];
}> = ({ title, messages }) => {
    return (
        <div className={styles.attentionBox}>
            <div className={styles.attentionTitle}>
                <SvgIcon name="attention" />
                <span>{title}</span>
            </div>
            {messages.map((message, idx) => (
                <div key={idx} className={styles.message}>
                    {message}
                </div>
            ))}
        </div>
    );
};

export default AttentionBox;
